import { Form, Select, Tooltip } from "antd";
import { FormattedMessage } from "react-intl";

const { Item } = Form;
const { Option } = Select;

const SelectItem = ({
  allowClear = true,
  formItemLayout,
  initialValue,
  placeholder,
  showSearch,
  wrapperCol,
  fieldName,
  className,
  onSelect,
  disabled,
  labelCol,
  required,
  optional,
  multiple,
  useCode,
  message,
  options,
  toolTip,
  noStyle,
  hidden,
  label,
}) => (
  <Item
    label={label}
    hidden={hidden}
    name={fieldName}
    noStyle={noStyle}
    initialValue={initialValue}
    rules={[
      {
        required: (required || message) && !optional,
        message: required ? (
          <FormattedMessage
            id="messages.input.required"
            defaultMessage="Tento údaj je povinný!"
          />
        ) : (
          message
        ),
      },
    ]}
    labelCol={
      labelCol ? { span: labelCol } : formItemLayout && formItemLayout.labelCol
    }
    wrapperCol={
      wrapperCol
        ? { span: wrapperCol }
        : formItemLayout && formItemLayout.wrapperCol
    }
  >
    <Select
      disabled={disabled}
      onSelect={onSelect}
      className={className}
      allowClear={allowClear}
      showSearch={showSearch}
      placeholder={placeholder}
      mode={multiple ? "multiple" : undefined}
      filterOption={
        showSearch
          ? (input, option) =>
              option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              (option.children.props &&
                option.children.props.title
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0)
          : undefined
      }
    >
      {options &&
        options.map((o, i) => (
          <Option
            key={i}
            value={o.id || o.code}
            title={showSearch ? o.name : undefined}
          >
            {toolTip ? (
              <Tooltip title={o.code}>{o.name}</Tooltip>
            ) : useCode ? (
              o.code
            ) : (
              o.name
            )}
          </Option>
        ))}
    </Select>
  </Item>
);

export default SelectItem;
